import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { lovable } from '@/integrations/lovable/index';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

export default function AdminLogin() {
  const { session, isAdmin, loading } = useAdminAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && session && isAdmin) navigate('/admin', { replace: true });
  }, [session, isAdmin, loading, navigate]);

  const signIn = async () => {
    setBusy(true);
    const result = await lovable.auth.signInWithOAuth('google', {
      redirect_uri: `${window.location.origin}/admin`,
    });
    if (result.error) {
      toast.error('ההתחברות נכשלה');
      setBusy(false);
    }
  };

  return (
    <div dir="rtl" className="min-h-screen flex items-center justify-center bg-neutral-50 p-6">
      <Card className="w-full max-w-md p-8 space-y-6">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-semibold">ניהול הקליניקה</h1>
          <p className="text-sm text-muted-foreground">היכנס/י עם חשבון Google כדי לנהל את הקליניקה.</p>
        </div>
        {loading || (session && isAdmin === null) ? (
          <p className="text-sm text-center text-muted-foreground">בודק הרשאות…</p>
        ) : session && isAdmin === false ? (
          <div className="text-center space-y-3">
            <p className="text-sm text-red-600">לחשבון הזה אין הרשאות ניהול.</p>
            <p className="text-xs text-muted-foreground break-all">מחובר/ת בתור: {session.user.email}</p>
            <Button variant="outline" onClick={() => supabaseSignOut()}>התנתקות</Button>
          </div>
        ) : (
          <Button onClick={signIn} disabled={busy} className="w-full">
            {busy ? 'מעביר…' : 'המשך עם Google'}
          </Button>
        )}
      </Card>
    </div>
  );
}

async function supabaseSignOut() {
  const { supabase } = await import('@/integrations/supabase/client');
  await supabase.auth.signOut();
  window.location.reload();
}
